var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.qrCode)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.qrLoading),expression:"qrLoading"}]},[_c('img',{attrs:{"src":_vm.qrCode,"alt":"QR Code"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }